import React, { Component } from "react";

import { FIXED2 } from "../../tools/fixedTools";
import NumberFormat from "react-number-format";
import Queries from "../../queries/queries2";
import { graphql } from "react-apollo";

class CurrencyInput extends Component {
  constructor(props) {
    super(props);
    const value = props.value ? props.value : 0;
    this.state = {
      value: this.addZeroes(value.toString())
    };
  }

  componentWillReceiveProps(nextProps) {
    // update display with decimal
    // console.log('CurrencyInput willreceive props', props)
    // console.log('CurrencyInput componentWillReceiveProps', nextProps)
    const value = nextProps.value ? nextProps.value : 0;
    this.setState({ value: this.addZeroes(value.toString()) });
  }

  handleFocus = event => {
    event.target.select();
  };

  addZeroes = num => {
    // console.log('addZeroes', num);
    var value = Number(num);
    var res = num.split(".");
    if (num.indexOf(".") === -1) {
      value = value.toFixed(2);
      num = value.toString();
    } else if (res[1].length < 3) {
      value = value.toFixed(2);
      num = value.toString();
    }
    return num;
  };

  render() {
    // console.log("currencyinput render", this.props)
    // const symbol =
    //   (this.props.currency.currency && this.props.currency.currency.symbol) ||
    //   "";
    const thousandSeparator =
      (this.props.currency.currency &&
        this.props.currency.currency.thousandSeparator) ||
      " ";

    let decimalSeparator =
      (this.props.currency.currency &&
        this.props.currency.currency.decimalSeparator) ||
      ",";

    // console.log("thousandSeparator", thousandSeparator)
    // const decimalSeparator = (this.props.currency.Currency && this.props.currency.Currency.decimalSeparator) || false

    // console.log("CurrencyInput value=", this.state.value);
    // console.log(
    //   "CurrencyInput code=",

    //   this.props.currency.currency && this.props.currency.currency.code
    // );
    // console.log("CurrencyInput currency=", this.props.currency);
    // console.log("CurrencyInput thousandSeparator=", thousandSeparator);

    if ( decimalSeparator === undefined || decimalSeparator === "")
      decimalSeparator = thousandSeparator === "." ? "," : ".";

    const decimalScale = this.props.digit !== undefined ? this.props.digit : 2;

    const style = {
      ...this.props.style,
      textAlign: "right"
    }

    return (
      <NumberFormat
        autoFocus={!!this.props.autoFocus}
        style={style}
        disabled={!!this.props.disabled}
        className={`form-control ${this.props.textColor}`}
        value={this.state.value}
        decimalScale={decimalScale}
        displayType={this.props.text ? "text" : "input"}
        fixedDecimalScale={true}
        decimalSeparator={decimalSeparator}
        allowNegative={true}
        thousandSeparator={thousandSeparator}
        isNumericString={true}
        // prefix={symbol}
        onFocus={this.handleFocus}
        onValueChange={values => {
          // const {formattedValue, value, floatValue} = values;
          // formattedValue = $2,223
          // value ie, 2223

          console.log("NumberFormat onValueChange", values);
          let r = values.value;
          if (values.value !== "-") r = this.addZeroes(values.value);

          const newState = { value: r };
          console.log("NumberFormat onValueChange", newState);
          this.setState(newState);
          //this.props.update({ value: FIXED2(r) });
        }}
        onBlur={() => {
          // update with decimal and notify on blur
          const r = this.addZeroes(this.state.value);
          // console.log("blurred values", r);
          this.setState({ value: r });
          this.props.update({ value: FIXED2(r) });
        }}
        onKeyDown={e => {
          const { key, target } = e;
          const { value } = target;
          console.log("target.selectionStart", target.selectionStart);
          console.log("target.value", target.value);

          if (key === "," || key === ".") {
            e.preventDefault();
            // target.value = `${value.substr(0, selectionStart)}.${value.substr(
            //   selectionStart,
            //   value.length
            // )}`;
            const dotPos = value.indexOf(".");
            const commaPos = value.indexOf(",");
            const pos = dotPos !== -1 ? dotPos : commaPos;
            console.log("target", target, pos);
            if (pos !== -1) {
              if (target.selectionStart >= pos) {
                target.selectionStart = pos + 1;
              } else {
                target.value = `${value.substr(1, target.selectionStart - 1)}`;
                // target.selectionStart = target.selectionStart - 2;
                this.setState({ value: target.value });
                //   .then(() => {
                //   target.selectionStart = pos;
                //   console.log("set pos", pos);
                // });
              }
            } else target.selectionStart += 1;
          }
        }}
      />
    );
  }
}

export default graphql(Queries.currencyByIdForCurrencyInput, {
  name: "currency"
})(CurrencyInput);
